







import SwitchByUa from '@/components/atoms/SwitchByUa.vue'
import { ApiContent } from '@/models/api/content'
import { ConditionalFreeContentsService } from '@/services/api/conditional-free-contents'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component({
  components: {
    SwitchByUa,
  },
})
export default class ConditionalFreeContentsContainer extends Vue {
  /**
   * ホスト配下では明示的にnullを渡すこと
   */
  @Prop({ required: true })
  readonly brandEnglishName: string | null

  @Prop({ required: true })
  readonly contentsName: string

  content: ApiContent | null = null

  async created() {
    await this.fetchFreeContents()
  }

  async fetchFreeContents(): Promise<void> {
    const result = await this.freeContentsService.get(this.contentsName)
    if (result.isLeft()) {
      return
    }

    this.content = result.value
  }

  private get freeContentsService(): ConditionalFreeContentsService {
    return this.brandEnglishName ?
      ConditionalFreeContentsService.createForBrand(this.brandEnglishName) :
      ConditionalFreeContentsService.createForHost()
  }
}
